import { useEffect, useState } from "react";
import axios from "axios";
import { leaseService } from "../../../../../../configs/constants";
interface TotalOverpaymentResponse {
  success: boolean;
  code: number;
  message: string;
  result: {
    totalOverpaymentRemaining: number;
  };
  error: string;
}

export const useTotalOverpaymentAmount = (tenantId?: string) => {
  const [loading, setLoading] = useState(false);
  const [totalOverpaymentRemaining, setTotalOverpaymentRemaining] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!tenantId) return;

    const fetchTotalOverpaymentAmount = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.post<TotalOverpaymentResponse>(`${leaseService}/booking/totalOverpaymentAmount`, {
          tenantId,
        });

        setTotalOverpaymentRemaining(response.data.result.totalOverpaymentRemaining || 0);
      } catch (err: any) {
        setError(err?.response?.data?.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchTotalOverpaymentAmount();
  }, [tenantId]);

  return {
    loading,
    totalOverpaymentRemaining,
    error,
  };
};
